import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  public local = this._local;
  public saveLocal = this._saveLocal;
  public clearLocal = this._clearLocal;
  public session = this._session;
  public saveSession = this._saveSession;
  public clearSession = this._clearSession;
  public clear = this._clear;
  public getAllSession = this._getAllSession;
  public getAllLocal = this._getAllLocal;

  constructor() {}

  private _local(key): any {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      return null;
    }
  }

  private _saveLocal(key, value): void {
    try {
      const asd = JSON.stringify(value);
      localStorage.setItem(key, asd);
    } catch (error) {
      console.log(error);
    }
  }

  private _clearLocal(key?: string): void {
    if (key) {
      localStorage.removeItem(key);
    } else {
      localStorage.clear();
    }
  }

  private _session(key): any {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (error) {
      return null;
    }
  }

  private _saveSession(key, value): any {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  private _clearSession(key?: string): void {
    if (key) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.clear();
    }
  }

  private _clear(): void {
    this._clearLocal();
    this._clearSession();
  }

  private _getAllSession(): any {
    return Object.keys(sessionStorage).reduce((obj, key) => {
      try {
        obj[key] = JSON.parse(sessionStorage.getItem(key));
        return obj;
      } catch (error) {
        return null;
      }
    }, {});
  }

  private _getAllLocal() {
    return Object.keys(localStorage).reduce((obj, key) => {
      obj[key] = localStorage.getItem(key);
      return obj;
    }, {});
  }
}
